<template>
  <div class="phonecode">
    <select class="form-controls" v-model="value" @change="selectChange">
      <option v-for="(item, index) in list" :value="`+${item.code}`" :key="`phonecode_${index++}`">+{{item.code}}</option>
    </select>
  </div>
</template>

<script>
import { getPhoneCode } from '@/api/base'
export default {
  name: 'PhoneCodeSelect',
  data() {
    return {
      value: '+86',
      list: []
    }
  },
  methods: {
    selectChange() {
      this.$emit('input', this.value)
    },
    getCode() {
      getPhoneCode().then(response => {
        this.list = response.data.countries
      })
    }
  },
  created() {
    this.getCode()
  }
}
</script>
<style>
.phonecode {
  position: relative;
  overflow: hidden;
}
.phonecode .form-controls {
  background: #f6f6f6;
  height: 100%;
}
.phonecode::after {
  position: absolute;
  content: '';
  top: 0;
  right: 0;
  bottom: 0;
  width: 20px;
  background: url('../assets/img/select_arrow.png') no-repeat center center;
  background-size: 6px auto;
  border-left: 1px solid #dadada;
}
</style>
